/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React, { useState, useEffect } from 'react';
import { Input, Space, Typography, List } from 'antd';
import { Button } from '@/uiKit';
import { Navigate } from 'react-router-dom';
import AppUtil from '@/utils/AppUtil';
import { useSelector } from 'react-redux';
import { userSelector } from '@/stores/slices/user';
import { useOnPingSubscription, usePingMutation } from '../generated/graphql';

const { Title } = Typography;

function MessageList({ channel }: { channel: string }) {
  const { data: subscriptionData } = useOnPingSubscription({
    variables: { channel }
  });
  const [messages, setMessages] = useState<{ channel: string; data: string }[]>(
    []
  );

  useEffect(() => {
    if (subscriptionData?.onPing) {
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          channel: `${subscriptionData.onPing?.channel}`,
          data: `${subscriptionData.onPing?.data}`
        }
      ]);
    }
  }, [subscriptionData]);

  return (
    <div>
      <p>Messages:</p>
      <List
        dataSource={messages}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta title={item.channel} description={item.data} />
          </List.Item>
        )}
      />
    </div>
  );
}

function TestPage() {
  const [channel, setChannel] = useState('1');
  const [data, setData] = useState('hello world');
  const [ping, { data: responseData }] = usePingMutation();
  const [subscriptions, setSubscriptions] = useState<string[]>([]);
  const { username } = useSelector(userSelector);
  const isSupportUser = AppUtil.isSupportUser(username);

  const handleSubscribe = () => {
    setSubscriptions((prevSubscriptions) => [...prevSubscriptions, channel]);
  };

  const handlePing = () => {
    ping({ variables: { channel, data } });
  };

  if (!isSupportUser) {
    return <Navigate to="/404" replace />;
  }

  return (
    <div>
      <Title level={2}>Test Page</Title>
      <Space direction="vertical">
        <Input
          placeholder="Channel"
          value={channel}
          onChange={(e) => setChannel(e.target.value)}
        />
        <Input
          placeholder="Data"
          value={data}
          onChange={(e) => setData(e.target.value)}
        />
        <Button type="primary" onClick={handlePing}>
          Ping
        </Button>
        {responseData && (
          <div>
            <p>Response:</p>
            <p>Channel: {responseData.ping.channel}</p>
            <p>Data: {responseData.ping.data}</p>
          </div>
        )}
      </Space>
      <Title level={2}>Subscribe</Title>
      <Input
        placeholder="Channel"
        value={channel}
        onChange={(e) => setChannel(e.target.value)}
      />
      <Button type="primary" onClick={handleSubscribe}>
        subscribe
      </Button>
      {subscriptions.map((channel) => (
        <MessageList key={channel} channel={channel} />
      ))}
    </div>
  );
}

export default TestPage;
